import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const FloatingContact = () => {
  return (
    <div className="fixed bottom-8 right-8 z-[90] flex flex-col items-end gap-4">
      {/* Vertical Pill Label */}
      <Link to="/contact">
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          whileHover={{ x: -5, scale: 1.05 }}
          className="hidden sm:flex bg-gradient-to-l from-pink-500 to-purple-600 text-white py-6 px-3 rounded-full shadow-2xl border border-white/20 items-center justify-center group relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
          <span 
            className="font-heading font-bold uppercase tracking-[0.2em] text-[10px] whitespace-nowrap origin-center rotate-180" 
            style={{ writingMode: 'vertical-rl' }}
          >
            Contact Us
          </span>
        </motion.button>
      </Link>

      {/* Circular Chat Button */}
      <Link to="/contact">
        <motion.button
          initial={{ scale: 0, rotate: -45 }}
          animate={{ scale: 1, rotate: 0 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white flex items-center justify-center shadow-[0_10px_40px_rgba(37,99,235,0.5)] relative group"
        >
          <span className="absolute inset-0 rounded-full bg-blue-500 animate-ping opacity-20 group-hover:hidden" />
          <div className="relative transform group-hover:scale-110 transition-transform">
            <MessageCircle className="w-8 h-8 fill-current" strokeWidth={1.5} />
          </div>
          <div className="absolute right-full mr-4 bg-gray-900/90 backdrop-blur-md text-white px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all translate-x-2 group-hover:translate-x-0 pointer-events-none shadow-2xl border border-white/10">
             Need help? Contact us!
          </div>
        </motion.button>
      </Link>
    </div>
  );
};

export default FloatingContact;
